<template>
  <v-card color="primary" class="rounded-sm">
    <v-card-text>
      <v-container>
        <v-form v-model="cupForm" ref="form">
          <v-row>
            <v-col cols="12">
              <BaseInput v-model="cupFormData.cup">
                <template v-slot:label>CUP</template>
              </BaseInput>
              <v-menu
                v-model="menuVigenciaCup"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="vigenciaCupFormatted"
                    label="Fecha de Emisión"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                    hint="Formato de fecha: DD/MM/YYYY"
                  />
                </template>
                <v-date-picker
                  v-model="cupFormData.vigenciaCup"
                  @input="menuVigenciaCup = false"
                  locale="es"
                  no-title
                ></v-date-picker>
              </v-menu>

              <v-file-input
                v-model="cupFormData.urlAdjunto"
                label="Oficio adjunto"
                rounded
                filled
                background-color="transparent"
                color="secondary"
                dense
              ></v-file-input>

              <v-textarea
                label="Observaciones"
                v-model="cupFormData.observaciones"
                no-resize
                rows="4"
                rounded
                filled
                dense
                color="secondary"
                background-color="transparent"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton @click="triggerUpdateCup()" :loading="loading">Actualizar CUP</TextButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import BaseInput from '../../../base/BaseInput.vue'
import TextButton from '../../../base/TextButton.vue'
import moment from 'moment'

export default {
  components: {
    BaseInput,
    TextButton,
  },
  props: {
    idPersonal: {
      type: Number,
      required: true,
    },
    cupToUpdate: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      cupForm: false,
      loading: false,
      menuVigenciaCup: false,
      cupFormData: {
        cup: '',
        vigenciaCup: '',
        observaciones: '',
        urlAdjunto: null,
      },
    }
  },
  computed: {
    vigenciaCupFormatted() {
      return this.cupFormData.vigenciaCup && moment(this.cupFormData.vigenciaCup, 'YYYY-MM-DD').isValid()
        ? moment(this.cupFormData.vigenciaCup, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : ''
    },
  },
  watch: {
    cupToUpdate: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.cupFormData = {
            cup: newVal.cup || '',
            vigenciaCup:
              newVal.vigenciaCup && moment(newVal.vigenciaCup, 'DD/MM/YYYY hh:mm:ss a').isValid()
                ? moment(newVal.vigenciaCup, 'DD/MM/YYYY hh:mm:ss a').format('YYYY-MM-DD')
                : null,
            observaciones: newVal.observaciones || '',
            urlAdjunto: null,
          }
        }
      },
    },
  },
  methods: {
    ...mapActions('cups', ['updateCup']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async triggerUpdateCup() {
      try {
        if (!this.cupToUpdate || !this.cupToUpdate.idHistCup) {
          console.error('El idHistCup es inválido o no está definido:', this.cupToUpdate)
          this.SET_SNACKBAR_MESSAGE('No se puede actualizar el CUP. El identificador es inválido.')
          return
        }

        this.loading = true

        let formData = new FormData()
        formData.append('CUP', this.cupFormData.cup)
        formData.append(
          'vigenciaCup',
          this.cupFormData.vigenciaCup ? moment(this.cupFormData.vigenciaCup).format('DD/MM/YYYY HH:mm:ss a') : ''
        )
        formData.append('observaciones', this.cupFormData.observaciones || '')

        if (this.cupFormData.urlAdjunto) {
          formData.append('adjunto', this.cupFormData.urlAdjunto)
        }

        await this.updateCup({
          idPersonal: this.idPersonal,
          idHistCup: this.cupToUpdate.idHistCup,
          payload: formData,
        })

        this.resetForm()
        this.$emit('close')
      } catch (error) {
        console.error('Ocurrió un error al actualizar el CUP:', error)
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al actualizar el CUP.')
      } finally {
        this.loading = false
      }
    },

    resetForm() {
      this.cupFormData = {
        cup: '',
        vigenciaCup: null,
        observaciones: '',
        urlAdjunto: null,
      }
      if (this.$refs.form) this.$refs.form.resetValidation()
    },
  },
}
</script>

<style scoped>
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep input,
::v-deep textarea {
  color: #e0e0e0 !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

::v-deep .v-date-picker-header {
  background: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}

::v-deep .v-date-picker-table .v-btn.v-btn--active {
  background-color: var(--v-secondary-base) !important;
  color: white !important;
}

::v-deep .v-date-picker-table .v-btn:hover {
  background-color: rgba(var(--v-secondary-base-rgb), 0.2) !important;
}
</style>
